import { fetchAndParse, CheckStatus } from '../utils/ajax';
import { getTenantId } from '../utils/tenant';

export const signOut = async () => {
    await fetch('/api/draw/1/authentication/signout', {
        method: 'POST',
    }).then(CheckStatus);
};

export const signOutSSO = async () => {
    const response = await fetchAndParse<{ redirectUri: string | null }>({
        url: '/api/draw/1/authentication/saml/signout',
        method: 'POST',
        headers: {
            ManyWhoTenant: getTenantId(),
        },
    });

    return response;
};
